module.exports = __webpack_public_path__ + "img/x3.85421e2b.png";